import React from 'react'
import { styled } from '~/app/components'

/**
 * Dash component
 * author: soojin.oh
 */

export type DashProps = {
  dotted?: boolean
}

/**
 * 스타일 통일함
 */
const Container = styled.div<{ dotted: boolean }>`
  padding: ${({ dotted }) => (dotted ? '1.6rem 2rem 1rem' : '2rem')};
`
const Line = styled.div`
  height: 1px;
  border-bottom: 2px dashed ${({ theme: { color } }) => color.gray100};
`

// Dash component
const Dash: React.FunctionComponent<DashProps> = function ({ dotted = false }) {
  return (
    <Container dotted={dotted}>
      <Line className={dotted ? 'dotted' : 'dashed'} />
    </Container>
  )
}

export default Dash
